import React from 'react';
import { DialogTitle } from '@/Components/shadcn/dialog';
import UIStrings from '@/Utils/UIStrings';

const AssessmentResetDialogHeader = (): React.JSX.Element => {
    return <DialogTitle>{UIStrings.ResetAssessment}</DialogTitle>;
};

export default AssessmentResetDialogHeader;
